import React, { Fragment } from "react";
import moment from "moment";
import { Dropdown, Menu } from "antd";
import _ from "lodash";

const kpisListColumn = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id"
  },
  {
    title: "Label",
    dataIndex: "Label",
    key: "short_label",
    render: (text, record, index) => (
      <Fragment>
        {record.short_label && record.long_label && (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item>{record.long_label}</Menu.Item>
              </Menu>
            }
          >
            <a className="ant-dropdown-link">{record.short_label}</a>
          </Dropdown>
        )}
      </Fragment>
    )
  },
  {
    title: "Source",
    dataIndex: "source",
    key: "source"
  },
  {
    title: "Format",
    dataIndex: "format",
    key: "format",
    render: (text, record, index) => {
      return (
        <Fragment>
          {record.format &&
          (record.format.toLowerCase() === "checkbox" || record.format.toLowerCase() === "radio") &&
          Array.isArray(record.values) ? (
            <Dropdown
              overlay={
                <Menu>
                  {record.values.map(value => {
                    if (value.indexOf("@") === -1) return <Menu.Item>- {value}</Menu.Item>;
                    return <Menu.Item style={{ color: "#E56A01" }}>{value} (titre)</Menu.Item>;
                  })}
                </Menu>
              }
            >
              <a className="ant-dropdown-link">{text}</a>
            </Dropdown>
          ) : (
            text
          )}
        </Fragment>
      );
    }
  },
  {
    title: "Type de calcul",
    dataIndex: "calculation_type",
    key: "calculation_type",
    render: (text, record, index) => (
      <Fragment>
        {record.calculation_type && record.calculation && (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item>{record.calculation}</Menu.Item>
              </Menu>
            }
          >
            <a className="ant-dropdown-link">{record.calculation_type}</a>
          </Dropdown>
        )}
      </Fragment>
    )
  },
  {
    title: "Priorité",
    dataIndex: "priority",
    key: "priority"
  },
  {
    title: "Min/Max",
    dataIndex: "rules",
    key: "rules",
    render: (text, record, index) => {
      const { rules } = record;
      if (!Array.isArray(rules)) return "-";
      return (
        <span>
          {rules[0]} / {rules[1]}
        </span>
      );
    }
  },
  {
    title: "Ids des kpi dépendances",
    dataIndex: "kpi_dependencies",
    key: "kpi_dependencies",
    render: (text, record, index) => {
      const { kpi_dependencies } = record;

      return _.isEmpty(kpi_dependencies) ? "Non" : kpi_dependencies.join(", ");
    }
  },
  // {
  //   title: "Autre dependences",
  //   dataIndex: "other_dependencies",
  //   key: "other_dependencies",
  //   render: (text, record, index) => {
  //     const { other_dependencies } = record;

  //     return (other_dependencies.map((clientId, index) =>
  //       <span>{clientId} {index < other_dependencies.length - 1 ? ',' : ''} </span>))
  //   }
  // },
  // {
  //   title: "Result format",
  //   dataIndex: "result format",
  //   key: "result format",
  // },
  {
    title: "Questionnaire",
    dataIndex: "survey_display",
    key: "survey_display",
    render: (text, record, index) => {
      const { survey_display, question } = record;

      return survey_display ? (
        <Fragment>
          <div>Oui</div>
          <div>{question}</div>
        </Fragment>
      ) : (
        "Non"
      );
    }
  },
  {
    title: "Statistique",
    dataIndex: "dashboard_display",
    key: "dashboard_display",
    render: (text, record, index) => {
      const { dashboard_display } = record;

      return dashboard_display ? "Oui" : "Non";
    }
  },
  {
    title: "Date de création",
    dataIndex: "create_data",
    key: "create_date",
    render: (text, record, index) => {
      const { create_date } = record;

      return moment(create_date).format("DD/MM/YYYY");
    }
  }
];

export default kpisListColumn;



// WEBPACK FOOTER //
// src/containers/admin/kpis/KpisList.utils.js